const CertifiedBody = () => {
  return (
    <p>
      The products listed on the PCL must be considered in the context of the
      environment of use, including appropriate risk analysis and system
      accreditation requirements. Customers must ensure that the products
      selected will provide the necessary security functionality for their
      architecture.
    </p>
  );
};
export default CertifiedBody;
